import React from 'react';
import { Box } from '@mui/material';

import StickyFooterWrapper from '../../StickyFooterWrapper';
import UserVotesInfo from '../../../Shared/UserVotesInfo/UserVotesInfo';
import { isIdea } from '../../../../../Utils/Post';
import InteractionsBox from '../../../Shared/InteractionsBox';

function Footer({ post, space }: any) {
  const parent = post.included.source;
  const canVote = post.actions?.find((action: any) => action.name === 'vote_support');

  if (!isIdea(post.type)) {
    return null;
  }

  if (parent.voting_options && canVote) {
    return (
      <StickyFooterWrapper height="140">
        <Box sx={{ mb: 2 }}>
          <UserVotesInfo post={post} parent={parent} space={space} />
        </Box>
        <InteractionsBox
          post={post}
          space={space}
          direction="row"
          ctaVariant="outlined"
          isResponsive
          onlyPrimaryActions
          size="small"
        />
      </StickyFooterWrapper>
    );
  }

  return (
    <StickyFooterWrapper>
      <InteractionsBox
        post={post}
        space={space}
        direction="row"
        ctaVariant="outlined"
        isResponsive
        onlyPrimaryActions
        size="small"
      />
    </StickyFooterWrapper>
  );
}

export default Footer;
